import { Heading, Icon, useIsDesignLanguage, DesignLanguage } from '@afterpaytouch/core'
import { useTranslation } from '../../utils/convergence'
import React, { FunctionComponent } from 'react'
import { AppLink } from '../AppLink'
import { Route, useRoutePageName } from '../../config/router'
import { pressedPageReturnEventName } from '../../model/monitoring'
import { getLinkText } from './utils'
import { useIconSize } from './hooks'
import styles from './style.module.css'
import clsx from 'clsx'

interface BackLinkProps {
  backTo: Route
  disabled?: boolean
  linkText?: string
  hideText?: boolean
}

export const BackLink: FunctionComponent<BackLinkProps> = ({ backTo, disabled = false, linkText, hideText = false }) => {
  const { t } = useTranslation(['common'])
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const fromPage = useRoutePageName()
  const iconSize = useIconSize()
  const text = linkText ?? getLinkText(backTo, t)
  const backLinkClassname = clsx(styles.backLink, isArcadeDesignLanguage && styles.withGap)

  return (
    <AppLink disabled={disabled} route={backTo} trackEventName={pressedPageReturnEventName(fromPage)}>
      <div className={backLinkClassname} data-testid='back-link-container'>
        <Icon.CaretLeft color={disabled ? 'Gray80' : 'Black'} size={iconSize} title={t('common:backTo', { page: text })} role='img' />
        {!hideText && (
          <Heading size='M' renderAs='span'>
            {text}
          </Heading>
        )}
      </div>
    </AppLink>
  )
}
